import {
  SR_API_ACTION_LOAD_FUZZY_SEARCH_LISTINGS,
} from 'api/actionTypes';

export default async function loadFuzzySearchListings({ state, apiClient }) {
  await apiClient.postWithState({
    action: SR_API_ACTION_LOAD_FUZZY_SEARCH_LISTINGS,
    state: state,
    onSuccess(listings) {
      state.set(['fuzzySearchListings'], listings);
    },
  });
}
